'use strict';

/**
 * A directive that scrolls an element in chunks, smoothly.
 *
 * This directive gets defined on the container designed to scroll, and `ms-smooth-scroll-section` on the child sections.
 * It makes use of Tween.js (https://github.com/tweenjs/tween.js).
 *
 */
(function () {
  'use strict';

  angular.module('msUtility').directive('msProgressAni', msProgressAni);

  msProgressAni.$inject = ['$timeout'];

  /* @ngInject */
  function msProgressAni($timeout) {
    var STOP_ANI = false;
    var directive = {
      link: link,
      restrict: 'A',
      scope: false
    };
    return directive;

    function link(scope, element, attrs) {
      var progressTween = void 0;
      attrs.$observe('msProgressAni', function (newPct) {
        $timeout(function () {
          // If this element is currently scrolling, stop it before scrolling to the new location.
          if (progressTween) {
            progressTween.stop();
          }
          progressTween = createProgressTween(element, newPct);
          progressTween.start();
          animate();
        });
      });
    }

    function createProgressTween(element, endPercent) {
      STOP_ANI = false;

      var startWidth = 100 * parseFloat(element.css('width')) / parseFloat(element.parent().css('width'));
      var endWidth = parseInt(endPercent, 10);

      return new TWEEN.Tween({ width: startWidth }).to({ width: endWidth }).easing(TWEEN.Easing.Cubic.InOut).onUpdate(function (progressObject) {
        element.css({
          width: progressObject.width + '%'
        });
      }).onComplete(function () {
        STOP_ANI = true;
      });
    }

    function animate() {
      if (STOP_ANI) {
        return;
      }
      TWEEN.update();
      requestAnimationFrame(animate);
    }
  }
})();